import { IContactFunctionData } from './IContactFunctionData';
import { ISelectOption } from '../../ui-toolkit';
import { labelComparator } from '../../utilities/labelComparator';

export const activeThirdPartyContactsFunctionsOptions = (contactFunctions: IContactFunctionData[]): ISelectOption[] =>
  contactFunctions
    .filter((value) => value.isThirdParty && value.isActive)
    .map((fun) => ({
      label: fun.label,
      value: fun.id,
    }))
    .toSorted(labelComparator);
